"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
require("./AIContentStructureApi");
const AIContentStructureConstants_1 = require("./AIContentStructureConstants");
const request_1 = __importDefault(require("@hotmart/request"));
class AIContentStructureService {
}
_a = AIContentStructureService;
AIContentStructureService.postSuggestion = async (params) => {
    return await (0, request_1.default)(AIContentStructureConstants_1.AIContentStructureEndpointKeys.PostAIContentStructure, params);
};
exports.default = AIContentStructureService;
